import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const CoAList = lazy(() =>
    import(/* webpackChunkName: "CoALIST" */ './CoAList').then( async module => {
        // wait for fetching userinfo before rendering
        await checkAuth();
        // Only show My Loan List page if user loggedin is authenticated
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            // Register list reducer together with ERF List Route
            store.injectReducer('CoAList', reducer.listReducer);
            return module;
        }
    })
);

const CoARoutes = [
    {
        label: 'Configuration of Approvers',
        path: '/HRAutomation/ConfigurationofApprovers',
        menuName: 'ConfigurationofApprovers',
        component: CoAList,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
]

export default CoARoutes;